const BankOriginEnum = Object.freeze({
    MEXICO: 'mexico',
    EXTRANJERO: 'foreign',
    AMBAS: 'both',
});
export default BankOriginEnum;